import type { WalkthroughAssetEntry } from './walkthroughTypes';

// CB:BEGIN contractor-walkthrough-assets
export const contractorWalkthroughAssets: WalkthroughAssetEntry[] = [
  {
    id: 'cw-getting-started',
    role: 'contractor',
    sectionId: 'getting-started',
    title: 'Contractor portal landing',
    description: 'CoreBids contractor portal — Start Earning Today CTA and value props.',
    rawImage: '/help/contractor/c01_contractor_portal.png',
    annotatedImage: '/help/contractor/c01_contractor_portal.png',
    thumbnailImage: '/help/contractor/c01_contractor_portal.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'CoreBids contractor portal landing page',
    captureStatus: 'captured',
    sourceScreen: 'ContractorLandingPage',
    priority: 'high',
  },
  {
    id: 'cw-setup-verification',
    role: 'contractor',
    sectionId: 'account-setup-verification',
    title: 'Verification setup',
    description: 'Contractor verification form — business info, tabs for license, insurance, W-9, Stripe.',
    rawImage: '/help/contractor/c03_dashboard_setup.png',
    annotatedImage: '/help/contractor/c03_dashboard_setup.png',
    thumbnailImage: '/help/contractor/c03_dashboard_setup.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor verification setup form',
    captureStatus: 'captured',
    sourceScreen: 'ContractorVerification',
    priority: 'high',
  },
  {
    id: 'cw-dashboard',
    role: 'contractor',
    sectionId: 'dashboard-overview',
    title: 'Contractor dashboard',
    description: 'Actions, pipeline, and active work.',
    rawImage: '/help/contractor/s03_dashboard.png',
    annotatedImage: '/help/contractor/s03_dashboard.png',
    thumbnailImage: '/help/contractor/s03_dashboard.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor dashboard overview',
    captureStatus: 'captured',
    sourceScreen: 'ContractorDashboard',
    priority: 'high',
  },
  {
    id: 'cw-finding-projects',
    role: 'contractor',
    sectionId: 'finding-projects',
    title: 'Open projects',
    description: 'Finding projects for bidding.',
    rawImage: '/help/contractor/s04_find_projects.png',
    annotatedImage: '/help/contractor/s04_find_projects.png',
    thumbnailImage: '/help/contractor/s04_find_projects.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Finding projects in contractor dashboard',
    captureStatus: 'captured',
    captureMode: 'happy-path-demo',
    sourceScreen: 'CurrentBids',
    priority: 'high',
  },
  {
    id: 'cw-reviewing-jobs',
    role: 'contractor',
    sectionId: 'reviewing-jobs',
    title: 'Project details review',
    description: 'Reviewing scope before bidding.',
    rawImage: '/help/contractor/s05_project_details.png',
    annotatedImage: '/help/contractor/s05_project_details.png',
    thumbnailImage: '/help/contractor/s05_project_details.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor project details screen',
    captureStatus: 'captured',
    captureMode: 'happy-path-demo',
    sourceScreen: 'ProjectDetails',
    priority: 'high',
  },
  {
    id: 'cw-submit-bid',
    role: 'contractor',
    sectionId: 'submitting-a-bid',
    title: 'Quote form — materials & scope',
    description: 'Full bid form showing materials, warranty, color options, and scope of work.',
    rawImage: '/help/contractor/c09_quote_full_form.png',
    annotatedImage: '/help/contractor/c09_quote_full_form.png',
    thumbnailImage: '/help/contractor/c09_quote_full_form.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor quote form — materials, warranty, and scope fields',
    captureStatus: 'captured',
    captureMode: 'happy-path-demo',
    sourceScreen: 'ContractorQuoteBidForm',
    priority: 'high',
  },
  {
    id: 'cw-after-submit',
    role: 'contractor',
    sectionId: 'after-you-submit-a-bid',
    title: 'Review submitted quote',
    description: 'View of submitted bid and the PDF proposal the homeowner sees.',
    rawImage: '/help/contractor/c11_review_bid.png',
    annotatedImage: '/help/contractor/c11_review_bid.png',
    thumbnailImage: '/help/contractor/c11_review_bid.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor bid review and homeowner proposal PDF',
    captureStatus: 'captured',
    captureMode: 'happy-path-demo',
    sourceScreen: 'CurrentBids/ContractorDashboard',
    priority: 'high',
  },
  {
    id: 'cw-winning-job',
    role: 'contractor',
    sectionId: 'winning-a-job',
    title: 'Awarded — active project',
    description: 'Active project detail showing escrow funded, start date, and milestone list.',
    rawImage: '/help/contractor/c12_awarded_active.png',
    annotatedImage: '/help/contractor/c12_awarded_active.png',
    thumbnailImage: '/help/contractor/c12_awarded_active.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor awarded active project with escrow and milestones',
    captureStatus: 'captured',
    sourceScreen: 'ContractorProjectDetail',
    priority: 'medium',
  },
  {
    id: 'cw-project-execution',
    role: 'contractor',
    sectionId: 'project-execution',
    title: 'Active project — escrow & start',
    description: 'Active project showing escrow balance, start date, and pre-start checklist complete.',
    rawImage: '/help/contractor/c12_awarded_active.png',
    annotatedImage: '/help/contractor/c12_awarded_active.png',
    thumbnailImage: '/help/contractor/c12_awarded_active.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor active project with escrow and start date',
    captureStatus: 'captured',
    sourceScreen: 'ContractorProjectDetail',
    priority: 'high',
  },
  {
    id: 'cw-milestones',
    role: 'contractor',
    sectionId: 'milestones-uploads',
    title: 'Milestone evidence submission',
    description: 'Pre-start checklist complete, milestones with Submit Evidence buttons.',
    rawImage: '/help/contractor/c13_milestone_evidence.png',
    annotatedImage: '/help/contractor/c13_milestone_evidence.png',
    thumbnailImage: '/help/contractor/c13_milestone_evidence.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor milestone evidence submission',
    captureStatus: 'captured',
    sourceScreen: 'ContractorMilestonePage',
    priority: 'high',
  },
  {
    id: 'cw-completion',
    role: 'contractor',
    sectionId: 'completing-a-project',
    title: 'Milestone evidence submission',
    description: 'Milestones pending with Submit Evidence — final steps to completion.',
    rawImage: '/help/contractor/c13_milestone_evidence.png',
    annotatedImage: '/help/contractor/c13_milestone_evidence.png',
    thumbnailImage: '/help/contractor/c13_milestone_evidence.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor milestone completion steps',
    captureStatus: 'captured',
    sourceScreen: 'ContractorMilestonePage',
    priority: 'medium',
  },
  {
    id: 'cw-notifications',
    role: 'contractor',
    sectionId: 'notifications-explained',
    title: 'Verification approved email',
    description: 'CoreBids email confirming verification approval and access to projects.',
    rawImage: '/help/contractor/c_appendix_email.png',
    annotatedImage: '/help/contractor/c_appendix_email.png',
    thumbnailImage: '/help/contractor/c_appendix_email.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor verification approved email notification',
    captureStatus: 'captured',
    sourceScreen: 'Email/Notifications',
    priority: 'medium',
  },
  {
    id: 'cw-best-practices',
    role: 'contractor',
    sectionId: 'best-practices',
    title: 'Quote form best practices',
    description: 'Full quote form showing all required and recommended fields.',
    rawImage: '/help/contractor/c09_quote_full_form.png',
    annotatedImage: '/help/contractor/c09_quote_full_form.png',
    thumbnailImage: '/help/contractor/c09_quote_full_form.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Best practices in contractor quote form',
    captureStatus: 'captured',
    sourceScreen: 'ContractorQuoteBidForm',
    priority: 'low',
  },
  {
    id: 'cw-common-mistakes',
    role: 'contractor',
    sectionId: 'common-mistakes',
    title: 'Bid review — common issues',
    description: 'Submitted bid PDF review — what homeowners see and common bid gaps.',
    rawImage: '/help/contractor/c11_review_bid.png',
    annotatedImage: '/help/contractor/c11_review_bid.png',
    thumbnailImage: '/help/contractor/c11_review_bid.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor bid review for identifying common mistakes',
    captureStatus: 'captured',
    sourceScreen: 'CurrentBids',
    priority: 'medium',
  },
  {
    id: 'cw-support',
    role: 'contractor',
    sectionId: 'contact-support',
    title: 'Verification approved email',
    description: 'Email notification example — what contractors receive from CoreBids.',
    rawImage: '/help/contractor/c_appendix_email.png',
    annotatedImage: '/help/contractor/c_appendix_email.png',
    thumbnailImage: '/help/contractor/c_appendix_email.png',
    placeholderImage: '/help/placeholders/contractor-generic.svg',
    alt: 'Contractor email notification from CoreBids support',
    captureStatus: 'captured',
    sourceScreen: 'ContractorHelpPage',
    priority: 'medium',
  },
];
// CB:END contractor-walkthrough-assets

